import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import withRouter from '../../../lib/router/withRouter';
import CsQnaDetailWrap from '../../../views/cs/qna/detail/CsQnaDetailWrap';
import { csQnaActions } from '../../../store/modules/cs/qna';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { asyncSimpleModal } from '../../../lib/common';
import {
  CS_QNA_STATUS,
  UPDATE_CS_QNA_ACTIVE_MESSAGE,
  UPDATE_CS_QNA_SECRET_MESSAGE,
} from '../../../constants/service/app/csQnaConstants';
import { calcEditRatePercent } from '../../../lib/utils/feedbackUtils';

class CsQnaDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (qnaId) => {
    const { getCsQnaDetail } = this.props;

    getCsQnaDetail({
      qnaId,
      usersOtherQna: {
        pagination: LIST_PAGINATION_MODEL,
      },
    });
  };

  /**
   * 유저의 다른 문의 내역 조회
   */
  getUsersOtherQnaList = (data) => {
    const { csQnaDetail, getCsUsersOtherQnaList } = this.props;
    const { qnaId, userId, usersOtherQna } = csQnaDetail.qnaInfo;
    const { pagination } = usersOtherQna;

    getCsUsersOtherQnaList({
      userId,
      qnaId,
      pagination,
      ...data,
    });
  };

  /**
   *  상품 문의 상태 변경하기
   */
  changeQnaStatus = async (active) => {
    const { csQnaDetail, changeQnaStatus } = this.props;
    const { qnaId } = csQnaDetail.qnaInfo;
    const { productId } = csQnaDetail.productInfo;

    /**
     *  업데이트 될 상품 문의 상태
     */
    let status = null;

    /**
     *  노출 여부 : 활성
     */
    if (active) status = CS_QNA_STATUS.SUBMIT;
    else status = CS_QNA_STATUS.DELETE_FROM_ADMIN;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '상품 문의 활성화',
      message: UPDATE_CS_QNA_ACTIVE_MESSAGE[active],
    });

    if (!confirmResult) return;

    changeQnaStatus({
      status,
      qnaId,
      productId,
    });
  };

  /**
   *  상품 문의 상태 변경하기
   */
  changeQnaSecret = async (isSecret) => {
    const { csQnaDetail, changeQnaSecret } = this.props;
    const { qnaId } = csQnaDetail.qnaInfo;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '상품 문의 비밀글 여부',
      message: UPDATE_CS_QNA_SECRET_MESSAGE[isSecret],
    });

    if (!confirmResult) return;

    changeQnaSecret({
      qnaId,
      isSecret,
    });
  };

  /**
   *  상품 문의 답변 작성하기
   */
  onReply = () => {
    const { form, csQnaDetail, replyCsQnaDetail } = this.props;
    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, async (err) => {
      if (err) return;

      const { qnaInfo, productInfo } = csQnaDetail;
      const { qnaId, answer, memo, timeReply, question, aiGeneratedAnswer, aiKeywords } = qnaInfo;
      const { storeId, storeName } = productInfo;

      /**
       *  수정을 하는 경우에는 경고메시지 보여주기
       */
      if (timeReply) {
        const confirmResult = await asyncSimpleModal({
          type: 'confirm',
          title: '문의 답변 수정',
          message: '문의 답변을 수정하면, 이전의 답변 내용과 작성자 정보가 없어집니다.\n 그래도 진행을 하시겠습니까?',
        });

        if (!confirmResult) return;
      }

      // AI 답변 정보 준비 (슬랙 알림 및 피드백용)
      const aiNotifyData = aiGeneratedAnswer
        ? (() => {
            const isEdited = aiGeneratedAnswer !== answer;
            return {
              brand_id: storeId,
              brand_name: storeName,
              question: question,
              keywords: aiKeywords || '',
              ai_answer: aiGeneratedAnswer,
              final_answer: answer,
              is_edited: isEdited,
              edit_rate: isEdited ? calcEditRatePercent(aiGeneratedAnswer, answer) : 0,
            };
          })()
        : null;

      replyCsQnaDetail({
        qnaId,
        answer,
        memo,
        isUpdate: timeReply,
        slackNotifyData: aiNotifyData, // 슬랙 알림 데이터 전달 (saga에서 처리)
        feedbackData: aiNotifyData, // 피드백 데이터 전달 (saga에서 처리)
      });
    });
  };

  render() {
    const { csQnaDetail, form, setData } = this.props;

    return (
      <CsQnaDetailWrap
        form={form}
        setData={setData}
        csQnaDetail={csQnaDetail}
        changeQnaSecret={this.changeQnaSecret}
        getUsersOtherQnaList={this.getUsersOtherQnaList}
        changeQnaStatus={this.changeQnaStatus}
        onReply={this.onReply}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    csQnaDetail: state.csQna.csQnaDetail,
  };
};

const mapDispatchToProps = {
  setData: csQnaActions.setData,
  getCsQnaDetail: csQnaActions.getCsQnaDetail,
  changeQnaStatus: csQnaActions.changeQnaStatus,
  changeQnaSecret: csQnaActions.changeQnaSecret,
  getCsUsersOtherQnaList: csQnaActions.getCsUsersOtherQnaList,
  replyCsQnaDetail: csQnaActions.replyCsQnaDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(withRouter(CsQnaDetailContainer)));
